<template>

  <div id="ca-sidesheet-eliminacion" v-if="acuerdo_comercial">

    <ca-sidesheet
      :show.sync="show"
      titulo="ELIMINAR ACUERDO"
      tipo="warning"
      width="600px"
      :close_outside= false
      botonera_inferior
    >

      <!-- Contenido del sidesheet -->
      <div class="contenedor-sidesheet">

        <!-- Header sidesheet -->
        <header-label-tipo-acuerdo-comercial-sidesheet :acuerdo_comercial="acuerdo_comercial" />

        <!-- Nivel de tabs -->
        <v-tabs
          class="ca-tabs"
          v-model="tabs_primer_nivel"
        >
          <v-tab>Detalles del acuerdo</v-tab>
          <v-tab>Historial</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs_primer_nivel">

          <!-- Detalles del acuerdo -->
          <v-tab-item>

            <!-- Detalle de estados -->
            <detalle-estado-acuerdo-comercial :acuerdo_comercial="acuerdo_comercial" />

            <!-- Vista previa -->
            <vista-previa-acuerdo
              :acuerdo_comercial="acuerdo_comercial"
              modo_eliminacion
              class="mt-4"
            />

            <!-- Tabla total a facturar (opcional) -->
            <div v-if="acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO" class="pt-4">

              <!-- Utilizamos el slot para inyectar la tabla de totales a facturar -->
              <div slot="tabla-total-a-facturar">
                <tabla-total-a-facturar-acuerdo-comercial
                  v-if="acuerdo_comercial.consorcio"
                  :acuerdo_comercial="acuerdo_comercial"
                  :consorcio="acuerdo_comercial.consorcio"
                />
              </div>

            </div>

          </v-tab-item>

          <!-- Historial -->
          <v-tab-item>
            <vista-historial-acuerdo-comercial :acuerdo_comercial="acuerdo_comercial" class="mt-2"/>
          </v-tab-item>

        </v-tabs-items>

      </div>

      <!-- Botonera inferior -->
      <div slot="footer-izquierda">
        <v-btn class="boton-cancelar" @click="cerrar()">Cerrar</v-btn>
      </div>
      <div slot="footer-derecha">
        <v-btn class="mr-4" @click="confimarEliminacion()">Eliminar</v-btn>
      </div>

    </ca-sidesheet>

  </div>

</template>

<script>
import { AcuerdoComercial } from '../../../models/AcuerdoComercial';
import VistaPreviaAcuerdo from './vistas-sidesheet/VistaPreviaAcuerdo.vue';
import * as acuerdo_comercial_constantes from '../acuerdo-comercial.consts';
import './vistas-sidesheet/vistas-sidesheet-style.scss'; // Estilos en común para las vistas
import { trimUsuarioSales } from '../acuerdo-comercial.helpers';
import { formatFecha } from '@/components/vue_filters';
import HeaderLabelTipoAcuerdoComercialSidesheet from './HeaderLabelTipoAcuerdoComercialSidesheet.vue';
import DetalleEstadoAcuerdoComercial from './DetalleEstadoAcuerdoComercial.vue';
import TablaTotalAFacturarAcuerdoComercial from './TablaTotalAFacturarAcuerdoComercial.vue';
import VistaHistorialAcuerdoComercial from './vistas-sidesheet/VistaHistorialAcuerdoComercial.vue';

export default {
  name: 'SidesheetEliminacionAcuerdo',
  components: {
    VistaPreviaAcuerdo,
    HeaderLabelTipoAcuerdoComercialSidesheet,
    DetalleEstadoAcuerdoComercial,
    TablaTotalAFacturarAcuerdoComercial,
    VistaHistorialAcuerdoComercial
  },
  props:{
    show: { type: Boolean, default: false },
    acuerdo_comercial: { type: AcuerdoComercial, default: null}
  },
  data: () =>( {
    tabs_primer_nivel: 0,

    TIPO_ACUERDO_VINCULADO_A_CONSORCIO: acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO,
    TIPO_ACUERDO_POR_DEFECTO: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_LIBRE: acuerdo_comercial_constantes.TipoAcuerdo.LIBRE, // [acuerdo_libre - no esta en uso actualmente]
  }),
  watch: {

    /**
     * Cada vez que se abre el sidesheet, se visualiza el primer tab
     */
    show(mostrar_sidesheet_eliminacion){
      if(mostrar_sidesheet_eliminacion){
        this.tabs_primer_nivel = 0; // Reiniciamos para que siempre se muestre el primer tab
      }
    }
  },
  methods: {
    trimUsuarioSales,
    formatFecha,

    /**
     * Metodo para emitir evento al padre para cerrar el sidesheet de eliminación del AC
     */
    cerrar(){
      this.$emit('update:show', false);
    },

    /**
     * Metodo ejecutado al confirmar la eliminación del AC desde el sidesheet
     */
    confimarEliminacion(){
      this.$emit('acuerdo-comercial:confirmar-eliminacion');
      this.$emit('update:show', false); // evento two-way bind para cerrar el sidesheet
    },
  },
};
</script>

<style lang="scss">
#ca-sidesheet-eliminacion {

  .v-toolbar__title {
    color: color(dark-secund);
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
  }

  .boton-cancelar {
    color: color(negro);
    background-color: inherit;
    box-shadow: none;
    margin-left:8px;
  }

  .v-slide-group__wrapper {
    padding: 0;
  }

  .ca-tabs {
    .v-tab {
      width: 100%;
    }
  }
}
</style>